import React, { useRef, useState } from "react";
import { Lightning, UploadSimple, CheckCircle, Spinner } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const CLASS_COLORS = {
  A4: "#1E7D34", A3: "#2C8C3C", A2: "#42A04A", A1: "#5BB45A",
  A: "#5BB45A", B: "#A6C24A", C: "#E0CC36", D: "#E8A33A",
  E: "#DD7E37", F: "#D45034", G: "#B22D2D",
};

export default function ApeUploader({ propertyId, currentClass, onUpdate }) {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const onPick = () => inputRef.current?.click();

  const onChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 12 * 1024 * 1024) {
      toast.error("Il PDF è troppo grande (max 12 MB)");
      return;
    }
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post(`/properties/${propertyId}/ape`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onUpdate?.(data.energy_class, data.summary);
      toast.success(`Classe ${data.energy_class} estratta`, {
        description: data.summary || `Confidenza ${Math.round((data.confidence || 0) * 100)}%`,
      });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Impossibile leggere l'APE");
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="card-flat p-6 mb-6" data-testid="ape-uploader">
      <div className="flex items-start gap-4">
        <div className="hidden sm:flex w-11 h-11 items-center justify-center bg-[#7C8B6E] text-[#FFFFFF] flex-shrink-0">
          <Lightning size={20} weight="duotone" />
        </div>
        <div className="flex-1">
          <span className="overline">Classe energetica · APE</span>
          <h3 className="font-editorial text-2xl mt-2">
            {currentClass ? (
              <>Classe <span style={{ color: CLASS_COLORS[currentClass] || "#7C8B6E" }}>{currentClass}</span></>
            ) : (
              "Aggiungi la classe energetica"
            )}
          </h3>
          <p className="mt-2 text-sm text-[#6B6A65] leading-relaxed max-w-xl">
            {currentClass
              ? "Caricane uno nuovo per aggiornare automaticamente i portali."
              : "Carica il PDF dell'APE: leggiamo la classe e i dati dell'edificio in 3 secondi e li aggiungiamo all'annuncio. Obbligatoria per pubblicare su Idealista, Immobiliare.it e Casa.it."
            }
          </p>
        </div>
        <div className="flex-shrink-0">
          <input
            ref={inputRef}
            type="file"
            accept="application/pdf,image/png,image/jpeg"
            onChange={onChange}
            className="hidden"
            data-testid="ape-file-input"
          />
          <button
            onClick={onPick}
            disabled={loading}
            className="btn-outline text-sm whitespace-nowrap disabled:opacity-60"
            data-testid="ape-upload-btn"
          >
            {loading
              ? <><Spinner size={14} className="animate-spin" /> Lettura…</>
              : currentClass
                ? <><CheckCircle size={14} weight="fill" /> Carica nuovo</>
                : <><UploadSimple size={14} weight="bold" /> Carica APE</>}
          </button>
        </div>
      </div>
    </div>
  );
}
